import React from "react";
import ReactDOM from "react-dom/client";
import "./CSS/Layout.css";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from "@mui/material/styles";

const palette = {
  // use tools to pick color
  // https://m3.material.io/theme-builder#/custom
  primary: {
    main: "#A22522",
    contrastText: "#fff",
    dark: "#761B19",
    light: "#6ADCD1"

  },
  secondary: {
    main: "#735751",
    contrastText: "#fff",
    dark: "#a2837c",
    light: "#5f4944"
  },
  third: {
    main: "#6a6a6a",
    contrastText: "#fff",
    dark: "#474747",
    light: "#858585"
  },
  fourth: {
    main: "#D6D5C9",
    contrastText: "#000",
    dark: "#f6f6f3",
    light: "#b0ae96"
  },
  dark: {
    main: "#454039",
    contrastText: "#fff",
    dark: "#2D2A25",
    light: "#655D53",
  },
  grey: {
    main: "#ebebeb",
    contrastText: "#000",
    dark: "#333A48",
    light: "#CFD4DD",
  },
  black: {
    main: "#000",
    contrastText: "#fff",
    dark: "#000",
    light: "#EDF2F4",
  }
};

const theme = createTheme({
  palette: palette,
  typography: {
    h1: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: palette.secondary.main,
      borderBottom: "0.5rem solid",
      width: "100%",
      margin: "2rem 0rem 1rem 0rem",
    },
    h2: {
      fontWeight: "bold",
      fontSize: "1.8rem",
      color: palette.secondary.main,
      textAlign: "center",
      margin: "4rem 0px"
    },
    h3: {
      color: palette.secondary.main,
      fontWeight: "bold",
      fontSize: "2rem",
      margin: "4rem 0rem",
      padding: "0.2rem 0.6rem",
      borderLeft: "8px solid var(--app-primary)",
    },
    h4: {
      fontSize: 20,
      textAlign: "left",
    },
    h5: {
      fontSize: 18,
      textAlign: "left",
    },
    h6: {
      fontSize: 16,
      textAlign: "left",
    },
    button: {
      textTransform: "none",
    },
    fontFamily: '"Nunito Sans", sans-serif',
    fontSize: 14,
  },
  components: {
    MuiTypography: {
      defaultProps: {
        component: "div"
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        content: {
          "& .MuiTypography-root": {
            textAlign: "left",
            fontWeight: "bold",
          },
        },
        root: {
          paddingBottom: "0px",
        }
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "0px 16px",
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: "black",
          fontSize: 14,
          "&.Mui-selected": {
            borderColor: "#00b0f0",
            color: "black"
          }
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textAlign: "end",
          alignSelf: "end",
          fontSize: "large",
          marginRight: "2rem",
          fontWeight: 400,
        }
      }
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
